import { validateUnitNumber } from '@planning/rt-stores/helpers'
import { FieldStore, ISubFormStore, validateSubForm } from '@tom-ui/utils'
import { makeObservable } from 'mobx'

export type SwapBodyCreationFormData = {
  unitNumber: string
  operator: string
  length: string
  height: string
  type: string
}

export class SwapBodyCreationFormStore implements ISubFormStore<SwapBodyCreationFormData> {
  unitNumber: FieldStore<string>
  operator: FieldStore<string>
  length: FieldStore<string>
  height: FieldStore<string>
  type: FieldStore<string>

  constructor(initialValues?: Partial<SwapBodyCreationFormData>) {
    makeObservable(this)

    this.unitNumber = new FieldStore(initialValues?.unitNumber ?? '', this.requiredAndValidUnit)
    this.operator = new FieldStore(initialValues?.operator ?? '')
    this.length = new FieldStore(initialValues?.length ?? '')
    this.height = new FieldStore(initialValues?.height ?? '')
    this.type = new FieldStore(initialValues?.type ?? '')
  }

  validate = () => validateSubForm(this)

  get data(): SwapBodyCreationFormData {
    return {
      unitNumber: this.unitNumber.value,
      operator: this.operator.value,
      length: this.length.value,
      height: this.height.value,
      type: this.type.value,
    }
  }

  requiredAndValidUnit = (val?: string): string | undefined => {
    if (val === null || val === '' || val === undefined) {
      return 'fieldIsRequired'
    }
    if (!validateUnitNumber(val)) {
      return 'invalidUnitNumber'
    }
    return undefined
  }
}
